import React, { Component } from "react";
import PropTypes from "prop-types";
import { Col } from "react-bootstrap";
import { connect } from "react-redux";

import { permitted, userPermissions } from "../../utils/security";
import SidebarMenuItems from "./items"; 
import pages from "../../constants/menu";

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: "",
      submenu: false,
    };
  }

  get menuItems() {
    return pages[0].contains.items;
  }

  filteredList = (menuItems) => {
    var result = [];

    menuItems.forEach(
      function (item) {
        var __add_it = !item.permissions;        

        if (__add_it) {
          result.push(item);
          return;
        }

        if (permitted(userPermissions(this.props.auth), item.permissions)) {
          result.push(item);
          return;
        }
      }.bind(this)
    );
    return result;
  };

  onShowSubmenu = (e, item) => {
    this.setState({
      item: item.id,
      submenu: !this.state.submenu,
    });
    return false;
  };

  onClick = (e, item) => {
    this.props.history.push(item.to);
  };

  onMouseOver = (e, item) => {
    this.setState({
      ...this.state,
      show: true,
    });
  }

  onMouseOut = (e, item) => {
    this.setState({
      ...this.state,
      show: false,
    });
  }

  render() {
    if (!this.props.auth) return;
    return (
      <Col xs="auto" className="side-menu-container" style={{ width: this.state.show ? "150px" : "35px"}}>
        <ul className="sw-25 side-menu mb-0 primary" id="menuSide" onMouseEnter={this.onMouseOver} onMouseLeave={this.onMouseOut}>
          <SidebarMenuItems items={pages[0].contains.items} />
        </ul>
      </Col>
    )
  }
}

Sidebar.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    profile: state.licensee.profile,
  };
};

export default connect(mapStateToProps)(Sidebar);
